const contact = `email: rehearsalnotice (at) gmail.com
`;

export default contact;
